export const round = (x: number) => Math.round(x * 100) / 100;

export const parseNumber = (maybeNumber: any, fallback: number) => {
  const aNumber = Number(maybeNumber ?? NaN);
  return Number.isNaN(aNumber) ? fallback : aNumber;
};

export const parseBoolean = (maybeBoolean: any, fallback: boolean) => {
  const compare = fallback ? "true" : "false";
  return maybeBoolean === compare || maybeBoolean === null
    ? fallback
    : !fallback;
};

export const parseText = (maybeText: string | null, fallback: string) => {
  return maybeText ?? fallback;
};
